export default "__VITE_ASSET__DnVmyx6K__"